var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inline-field-actions',{attrs:{"schema":_vm.schema}}),_vm._v(" "),_c('dropzone',{key:_vm.schema.model,ref:_vm.schema.model,attrs:{"id":_vm.schema.model,"options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.setValue,"vdropzone-removed-file":_vm.removeFile,"vdropzone-error":_vm.handleError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }